import { GetStaticPaths, GetStaticPathsResult, GetStaticProps } from "next";
import Head from "next/head";

import { RegionParlorsContainer } from "@/containers/RegionParlorsContainer";
import {
  getSidoFacilities,
  listSidosWithParlors,
} from "@/utils/regionFacilities";
import { buildRegionMeta, RegionPageProps } from "@/utils/buildRegionPageProps";
import { skipDevBuildInGetStaticPaths } from "@/utils/skipDevBuildInGetStaticPaths";

export const getStaticPaths: GetStaticPaths = async () => {
  const skipBuildResult =
    skipDevBuildInGetStaticPaths() as GetStaticPathsResult;

  if (skipBuildResult) {
    return skipBuildResult;
  }

  return {
    paths: listSidosWithParlors().map((sido) => ({ params: { sido } })),
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const data = getSidoFacilities(String(params?.sido));

  if (!data) {
    return { notFound: true };
  }

  return {
    props: {
      ...buildRegionMeta(data, "facility"),
      pagePublishedTime: "2026-08-06T00:00:00+09:00",
      // CDN_URL이 없는 환경에서 "undefined/ogimage.png"가 og:image로 나가지 않게 한다
      ...(process.env.NEXT_PUBLIC_CDN_URL
        ? { pageOgImage: `${process.env.NEXT_PUBLIC_CDN_URL}/ogimage.png` }
        : {}),
    },
  };
};

/**
 * 시도 페이지. 시군구 페이지와 같은 컨테이너를 쓴다.
 * 차이는 장례식장 리스트에 지역(시군구) 필터가 붙는 것뿐이다(sigunguOptions).
 */
const RegionFacilitySidoPage = ({ pageJsonLd, ...data }: RegionPageProps) => {
  return (
    <>
      {pageJsonLd && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: pageJsonLd }}
          />
        </Head>
      )}
      <RegionParlorsContainer {...data} focus="facility" />
    </>
  );
};

export default RegionFacilitySidoPage;
